module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    on: {
      "touchend": _vm.handleTouchEnd
    }
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.haveOverlay && _vm.isOverShow
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false)) : _vm._e()], 1), (_vm.show) ? _c('div', {
    ref: "dof-popup",
    class: ['dof-popup', _vm.pos],
    style: _vm.padStyle,
    attrs: {
      "height": _vm._height,
      "hack": _vm.isNeedShow
    },
    on: {
      "click": function () {}
    }
  }, [_vm._t("default"), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticStyle: {
      width: "750px",
      height: "20px",
      backgroundColor: "#F3F3F3"
    }
  }) : _vm._e(), (_vm.button && _vm.button.length > 0) ? _c('div', {
    staticClass: ["midea-actionsheet-bottom"]
  }, [_c('text', {
    staticClass: ["midea-actionsheet-btn", "leftBtn"],
    on: {
      "click": function($event) {
        _vm.actionsheetBtnClick(0, _vm.button[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.button[0]))]), (_vm.button.length > 1) ? _c('text', {
    staticClass: ["midea-actionsheet-btn", "rightBtn"],
    on: {
      "click": function($event) {
        _vm.actionsheetBtnClick(1, _vm.button[1])
      }
    }
  }, [_vm._v(_vm._s(_vm.button[1]))]) : _vm._e()]) : _vm._e(), _c('div', {
    style: {
      height: _vm.show && _vm.isipx ? '68px' : '0px'
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-2193e31c!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-select-picker/index.vue
// module id = 580
// module chunks = 0 1